var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-detail" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("googleBusiness.channelDetails"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-content" },
      [
        _c(
          "a-form-item",
          { attrs: { label: _vm.$t("googleBusiness.channelName") } },
          [
            _c("a-input", {
              model: {
                value: _vm.localChannel.name,
                callback: function ($$v) {
                  _vm.$set(_vm.localChannel, "name", $$v)
                },
                expression: "localChannel.name",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.localChannel.payload
          ? _c(
              "a-form-item",
              { attrs: { label: _vm.$t("googleBusiness.accountInfo") } },
              [
                _c("div", { staticClass: "account-info" }, [
                  _vm.localChannel.payload.accountName
                    ? _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("googleBusiness.accountName")) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.localChannel.payload.accountName)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.localChannel.payload.accountId
                    ? _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("googleBusiness.accountId")) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.localChannel.payload.accountId)),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a-form-item",
          { attrs: { label: _vm.$t("googleBusiness.status") } },
          [
            _c("a-switch", {
              model: {
                value: _vm.localChannel.enabled,
                callback: function ($$v) {
                  _vm.$set(_vm.localChannel, "enabled", $$v)
                },
                expression: "localChannel.enabled",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "status-text" }, [
              _vm._v(
                _vm._s(
                  _vm.localChannel.enabled
                    ? _vm.$t("googleBusiness.enabled")
                    : _vm.$t("googleBusiness.disabled")
                )
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-actions" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", loading: _vm.saving },
                on: { click: _vm.save },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("googleBusiness.save")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }